import React from 'react';
import { PanelHeader, Tabs, Tab, formatDate } from '@keplerco/core';
import { JsonViewer } from '../../../components/json-viewer/json-viewer';
import { formatJson } from '../../../library/helpers/format-json';
import { AgentResponseDetailDto } from '../../../overmind/actions';

enum TabIds {
  Response = 'Response',
  UserPrompt = 'User Prompt',
  SystemPrompt = 'System Prompt',
  JSONSchema = 'JSON Schema',
}

export function InformationSearchDetailsPanel({ response }: { response: AgentResponseDetailDto }): JSX.Element {
  const [activeTab, setActiveTab] = React.useState<TabIds>(TabIds.Response);

  return (
    <div className="panelContent">
      <PanelHeader title={response.displayName} subtitle={formatDate(new Date(response.dateCreated))}>
        <Tabs static>
          <Tab id={TabIds.Response} name={TabIds.Response} active={activeTab === TabIds.Response} onClick={() => setActiveTab(TabIds.Response)} />
          <Tab id={TabIds.UserPrompt} name={TabIds.UserPrompt} active={activeTab === TabIds.UserPrompt} onClick={() => setActiveTab(TabIds.UserPrompt)} />
          <Tab id={TabIds.SystemPrompt} name={TabIds.SystemPrompt} active={activeTab === TabIds.SystemPrompt} onClick={() => setActiveTab(TabIds.SystemPrompt)} />
          <Tab id={TabIds.JSONSchema} name={TabIds.JSONSchema} active={activeTab === TabIds.JSONSchema} onClick={() => setActiveTab(TabIds.JSONSchema)} />
        </Tabs>
      </PanelHeader>

      {activeTab === TabIds.Response && <JsonViewer data={formatJson(response.rawJsonResponse)} />}
      {activeTab === TabIds.UserPrompt && <pre>{response.userPrompt}</pre>}
      {activeTab === TabIds.SystemPrompt && <pre>{response.systemPrompt}</pre>}
      {activeTab === TabIds.JSONSchema && <JsonViewer data={formatJson(response.jsonSchema)} />}
    </div>
  );
}
